import { useEffect } from "react";
import Header from "../../../../../components/header";
import { WalletLogTab, WalletTab } from "../../hooks/use-wallet-tab";
import { useWalletContext } from "../../hooks/wallet-context";
import WalletLogsHeader from "./components/log-header";
import { WalletLogsBorder, WalletLogsWrapper } from "./style";
import { useWalletLogContext } from "../../hooks/wallet-log-context";
import WalletLogsFilter from "./components/log-filter";
import WalletLogsList from "./components/log-list";

const WalletLogs = () => {
  const { walletTab, logTab, setWalletTab, selectedPub } = useWalletContext();
  const {
    getSeedLogs,
    getPointLogs,
    getMileageLogs,
    setPub,
    pub,
    month,
    year,
  } = useWalletLogContext();

  // 지갑 탭에서 선택한 펍 필터 반영
  useEffect(() => {
    setPub(selectedPub);
  }, [walletTab]);

  // 최초 실행 api
  useEffect(() => {
    switch (logTab) {
      case WalletLogTab.POINT:
        getPointLogs();
        break;
      case WalletLogTab.SEED:
        getSeedLogs();
        break;
      case WalletLogTab.MILEAGE:
        getMileageLogs();
        break;
    }
  }, [pub, month, year]);

  const getHeaderText = () => {
    switch (logTab) {
      case WalletLogTab.POINT:
        return "매장이용권 상세내역";
      case WalletLogTab.SEED:
        return "통합 크레딧 상세내역";
      case WalletLogTab.MILEAGE:
        return "주류 마일리지 상세내역";
      case WalletLogTab.SUBPRIZE:
        return "부상 상세내역";
    }
  };

  return (
    <WalletLogsWrapper>
      <Header
        title={getHeaderText()}
        back={() => setWalletTab(WalletTab.WALLET)}
      />
      <WalletLogsHeader />
      <WalletLogsBorder />
      <WalletLogsFilter />
      <WalletLogsList />
    </WalletLogsWrapper>
  );
};

export default WalletLogs;
